// eslint-disable-next-line import/extensions
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'

export default {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$swal = swal
  },
}
